export default __webpack_public_path__ + "static/media/Badge.7dcaca4f.png";